import { ConstMap } from '@/utils/ConstMap';

export enum COMPANY_ACTIVE_STATUS {
  ACTIVE = 1,
  CHURNED = 2,
}

export const COMPANY_STATUS_MAP = new ConstMap([
  [COMPANY_ACTIVE_STATUS.ACTIVE, 'Active'],
  [COMPANY_ACTIVE_STATUS.CHURNED, 'Churned'],
]);
